import type { PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';

import { applySaveToRuntime } from './applySaveToRuntime';
import { useSaveStore } from './saveStore';
import { finishGamePlatformLoading } from '../../platform/gamePlatform';
import { captureException } from '../../monitoring';

export function SaveBootstrap({ children }: PropsWithChildren) {
  const initialize = useSaveStore((state) => state.initialize);
  const status = useSaveStore((state) => state.status);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    void initialize()
      .then((save) => {
        if (!active) {
          return;
        }
        applySaveToRuntime(save);
        void finishGamePlatformLoading().catch((error: unknown) => {
          captureException(error, 'platform-loading');
        });
        setReady(true);
      })
      .catch((error: unknown) => {
        captureException(error, 'save-bootstrap');
        if (active) {
          applySaveToRuntime(useSaveStore.getState().save);
          setReady(true);
        }
      });
    return () => {
      active = false;
    };
  }, [initialize]);

  if (!ready) {
    return (
      <main className="save-loading" aria-live="polite" aria-busy="true">
        <span aria-hidden="true">◆</span>
        <strong>正在校验存档</strong>
        <small>{status === 'loading' ? '同步本地行动记录…' : '初始化存档系统…'}</small>
      </main>
    );
  }

  return children;
}
